import React, { useState } from 'react';
import { isEmpty } from 'lodash';

import { Tabs } from '@metarouter-private/mr-mui';

import { useDrawerContext } from 'app/shared/contexts/drawer';

import DebuggerDrawerInputContent from './DebuggerDrawerContent/DebuggerDrawerInputContent';
import DebuggerDrawerOutputContent from './DebuggerDrawerContent/DebuggerDrawerOutputContent';
import DebuggerDrawerRequestContent from './DebuggerDrawerContent/DebuggerDrawerRequestContent';
import DebuggerDrawerResponseContent from './DebuggerDrawerContent/DebuggerDrawerResponseContent';
import DRAWER_TABS from './DRAWER_TABS';

export default function DebuggerDrawerTabs() {
  const { drawer } = useDrawerContext();
  const { eventData, initialTab } = drawer.data;

  const [activeTab, setActiveTab] = useState(initialTab ?? DRAWER_TABS.INPUT);
  const enabledTabs = getEnabledTabs(eventData);

  return (
    <Tabs
      value={activeTab}
      onChange={setActiveTab}
      tabs={[
        {
          label: 'Input',
          content: <DebuggerDrawerInputContent inputEvent={eventData.inputEvent} />,
          TabProps: { disabled: !enabledTabs.includes(DRAWER_TABS.INPUT) },
        },
        {
          label: 'Output',
          content: <DebuggerDrawerOutputContent outputEvent={eventData.outputEvent} />,
          TabProps: { disabled: !enabledTabs.includes(DRAWER_TABS.OUTPUT) },
        },
        {
          label: 'Request',
          content: (
            <DebuggerDrawerRequestContent
              requestHeaders={eventData.requestHeaders}
              requestBody={eventData.requestBody}
            />
          ),
          TabProps: { disabled: !enabledTabs.includes(DRAWER_TABS.REQUEST) },
        },
        {
          label: 'Response',
          content: <DebuggerDrawerResponseContent response={eventData.response} />,
          TabProps: { disabled: !enabledTabs.includes(DRAWER_TABS.RESPONSE) },
        },
      ]}
    />
  );
}

function getEnabledTabs(eventData) {
  const enabled = [];
  if (!isEmpty(eventData.inputEvent)) enabled.push(DRAWER_TABS.INPUT);
  if (!isEmpty(eventData.outputEvent)) enabled.push(DRAWER_TABS.OUTPUT);
  if (!isEmpty(eventData.requestHeaders)) enabled.push(DRAWER_TABS.REQUEST);
  if (!isEmpty(eventData.response)) enabled.push(DRAWER_TABS.RESPONSE);
  return enabled;
}
